var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideCloseButton)?_c('button',{staticClass:"button",on:{"click":_vm.clickHandler}},[_c('icon',{attrs:{"type":"close","color":_vm.color,"size":16}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }